import lodash from 'lodash';
import moment from 'moment';
import sectionLabels from '../sectionLabels';
import {getColor} from '../manageScore/components/colorForScorePath';
import colors from '../../../modules/theme/colors'

const dateFormatter = (value) => {
  return `<span>${moment(value).format('YYYY-MM-DD')}</span>`
};

const chartText = {
  fontWeight: 'lighter'
}

const overTimeXAxis = {
  paddingTop: '10px'
}

let chartTitle = {
  fontSize: '20px',
  fontWeight: 100,
};


export const scoreOverTime = (
  segments,
  dates,
  chartType
) => {

  return {
    colors: [
      "var(--color-6)", // Overall
      "var(--color-1)", // Reviews
      "var(--color-2)", // Social
      "var(--color-3)", // Listings
      "var(--color-4)", // Search
      "var(--color-5)", // Competitors
    ],
    chart: {
      marginRight: 30,
      type: chartType
    },
    title: {
      text: null,
    },
    legend: {
      // squareSymbol: true,
      symbolHeight: 12,
      symbolWidth: 12,
      symbolRadius: 6,
      itemStyle: chartText
    },
    tooltip: {
      formatter: function () {
        return `<span>${this.series.name} - ${Math.round(this.y * 10000) / 100} - [${ dateFormatter(this.key) }]</span>`
      },
      useHTML: true
    },
    xAxis: {
      labels: {
        y: 20,
        style: {...chartText, ...overTimeXAxis},
        enabled: true,
        formatter: function () {
          return dateFormatter(this.value);
        },
        useHTML: true,
        rotation: 0,
      },
      type: 'datetime',
      minorTickLength: 0,
      tickLength: 0,
    },
    yAxis: {
      max: 1,
      min: 0,
      labels: {
        enabled: false
      },
      title: {
        enabled: false
      },
    },
    credits: {
      enabled: false,
    },
    plotOptions: {
      series: {
        lineWidth: 4,
        connectNulls: true,
        marker: {
          enabled: null,
        },
      },
    },
    exporting: {
      enabled: false
    },
    series: segments.map(({ scorePath, segments }) => ({
      name: sectionLabels[scorePath],
      data: lodash.zip(dates, segments),
      marker: { enabled: false },
    })),
  }
}

export const scoreBreakdown = (
  path,
  data,
  chartType
) => {
  return {
    colors: [getColor(path)],
    chart: {
      marginRight: 30,
      type: chartType
    },
    title: {
      text: null,
    },
    legend: {
      enabled: false
    },
    tooltip: {
      formatter: function () {
        return `<span>${data.length === 1 ? '' : this.series.name + " - "}${Math.round(this.y * 10000) / 100} - [${ dateFormatter(this.key) }]</span>`
      },
      useHTML: true
    },
    xAxis: {
      lineColor: "var(--border-color)",
      labels: {
        y:20,
        style: chartText,
        enabled: true,
        useHTML: true,
        rotation: 0,
        formatter: function () {
          return dateFormatter(this.value);
        },
        type: 'datetime',
      },
      minorTickLength: 0,
      tickLength: 0,
      y: 20
    },
    yAxis: {
      gridLineColor: "var(--border-color)",
      max: 1,
      min: 0,
      labels: {
        enabled: false
        // style: chartText,
        // formatter: function () {
        //   return Math.ceil(this.value * 100);
        // }
      },
      title: {
        enabled: false
        // text: "Score",
        // style: chartText
      },
    },
    credits: {
      enabled: false,
    },
    plotOptions: {
      series: {
        lineWidth: 4,
        connectNulls: true,
        marker: {
          enabled: null,
        },
        enableMouseTracking: true
      }
    },
    exporting: {
      enabled: false
    },
    series: data.map(item => ({
      name: data.length === 1 ? 'Score' : item.name,
      data: item,
      marker: { enabled: false },
    }))
  }
}
